import { Outlet, useLoaderData } from "react-router-dom";
import { useEffect } from "react";
import { useSessionStore } from "../store/session.store";
import { getOrganization } from "../services/auth.service";
import { redirectToLogin } from "../helper/common.helper";

function PageContainer() {
	const { notSession, user } = useLoaderData();
	const { updateState } = useSessionStore();

	useEffect(() => {
		if (user) {
			updateState({ user });
			if (user.role === "organization" && user.organization_id) {
				getOrganization({ id: user.organization_id }, (res) => {
					updateState({ organization: res.data });
				});
			}
		}
	}, [user]);

	if (notSession || (user?.role === "organization" && !user?.organization_id)) {
		redirectToLogin();
		return null;
	}

	return <Outlet />;
}

export default PageContainer;
